import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { CompanyService, Company } from './company.service';
import { CommonService, Code } from '../app.service';
import { MessageService } from "../common/message.service";
import { GooglemapService, LocationInfo } from "../common/googlemap.service";
import { AppConstants, LOGON_INFO, CODE, COMP_TYPE, USER_TYPE } from '../app.constants';
import { User, UserService } from './user.service';
import { Member, MemberRegisterService } from './member-register.service';
import $ from 'jquery';


@Component({
    selector: 'company',
    templateUrl: 'company.component.html',
    providers: [CompanyService, UserService, MemberRegisterService, GooglemapService]
})
export class CompanyComponent implements OnInit, OnDestroy {

    CONST: any = AppConstants;

    COMP_TYPE: any = COMP_TYPE;

    logon_comp_id: string = LOGON_INFO.COMP_ID;
    logon_comp_type: string = LOGON_INFO.COMP_TYPE;

    companyList: Company[];
    currentCompany: Company;
    currentUser: User;

    member: Member;

    pageTitle: string = "営業所";

    isLeaveCompanyPage: boolean;
    isPartnerClientPage: boolean;

    // compTypeCodeList: Code[];

    totalCount: number;
    currPage: number;
    PAGE_SIZE: number = AppConstants.PAGE_SIZE;

    address_search_list: LocationInfo[];

    @ViewChild(NgForm) f: NgForm;

    constructor(
        public commonService: CommonService,
        public companyService: CompanyService,
        public messageService: MessageService,
        public mapService: GooglemapService,
        private router: Router,
        private userService: UserService,
        private memberRegisterService: MemberRegisterService
    ) {   }

    ngOnInit() {
        this.member = new Member(new Company, new User);

        // this.compTypeCodeList = CODE.COMP_TYPE;

        this.clearSelectCompany();

        this.currPage = 1;
        this.isLeaveCompanyPage = this.router.url.indexOf('leave') > -1;
        this.isPartnerClientPage = true;

        if (this.router.url.indexOf('client') > 0) {
            this.pageTitle = "荷主";
        } else if (this.router.url.indexOf('partner') > 0) {
            this.pageTitle = "傭車先";
        } else {
            this.isPartnerClientPage = false;
        }

        this.getCompanyList();
    }


    companyUpdateModalShow(execDiv: string, company: Company) {
        //新規登録の場合
        if (execDiv == this.CONST.REGIST) {
            this.clearSelectCompany();
            $('#companyUpdateModal .modal-title').text('【 '+this.pageTitle+'登録 】');
        }
        //更新の場合
        else {
            //objectをコピー
            this.currentCompany = Object.assign({},company);

            // if (company.user && company.user.length) {
            //     this.currentUser.userid = company.user[0].userid;
            //     this.currentUser.name = company.user[0].name;
            // }
            // else {
            //     this.currentUser.userid = "";
            //     this.currentUser.name = "";
            // }

            $('#companyUpdateModal .modal-title').text('【 '+this.pageTitle+'修正 】');
        }

        $('#companyUpdateModal').modal('show');
    }


    // checkUseridDuplicate(isValid: boolean) {
    //     if (isValid) {
    //         this.userService.checkUseridDuplicate(this.currentUser.userid)
    //         .subscribe(
    //             data => {
    //                 if (data['results'].length == 0) {
    //                     this.clearCustomError("userid");
    //                 }
    //                 else {
    //                     this.setCustomError("userid");
    //                 }
    //             }
    //         );
    //     }
    // }


    // checkPasswordEqual(isValid: boolean) {
    //     if (isValid) {
    //         if (this.currentUser.password != this.currentUser.passwordConfirm) {
    //             this.setCustomError("passwordConfirm");
    //         }
    //         else {
    //             this.clearCustomError("passwordConfirm");
    //         }
    //     }
    // }


    changeCompType() {
        if (this.currentCompany.comp_type == COMP_TYPE.PARTNER) {
            this.currentCompany.menu_type = "1";
            this.currentCompany.name = "本社";
        } else {
            this.currentCompany.menu_type = "";
            this.currentCompany.group_name = "";
            this.currentCompany.name = "";
        }
    }


    //郵便番号から住所を取得
    getZipcode(isValid: boolean) {
        if (!this.currentCompany.zipcode) {
            this.currentCompany.address = "";
            this.currentCompany.address_detail = "";
        }
        else if (this.currentCompany.zipcode && isValid) {
            /*
            this.commonService.getAddress(this.currentCompany.zipcode)
            .subscribe(
                data => {
                    if (data.size == 1) {
                        this.currentCompany.address = data.data[0]['allAddress'];
                        this.messageService.clearError();
                        $('#address_detail').focus();
                        this.isExistZipcode = true;
                    } else {
                        console.log(data.data[0]);
                        //this.currentCompany.address = '';
                        this.isExistZipcode = false;
                        //this.currentCompany.zipcode = '';
                        $('#zipcode').focus();
                    }
                },
                error => this.messageService.add("zipcode error!!!")
            );*/

            this.commonService.searchAddress(this.currentCompany.zipcode.replace('-',''))
                    .subscribe(
                        data => {
                            if (data['results'].length == 1) {
                                this.setAddress(data['results'][0]);
                            } else if (data['results'].length > 1) {
                                this.address_search_list = data['results'];
                                $('#addressSearchModal').modal('show');
                            } else {
                                this.messageService.addError("郵便番号に該当する住所が見つかりません。");
                            }
                        }
                    );
        }
    }

    //address検索結果modalからのcallback
    setAddress(locInfo: LocationInfo) {
        this.currentCompany.address = locInfo.todohuken + locInfo.address;
        this.messageService.clearError();
        $('#address_detail').focus();
    }


    //会社リスト取得
    getCompanyList() {
        //会社管理画面の場合
        if (this.router.url.indexOf("company") > -1) {
            this.companyService.getCompanyList(this.currPage, this.isLeaveCompanyPage, true)
                .subscribe(
                    data => {
                        this.companyList = data['results'];
                        this.totalCount = data['count'];
                    }
                );
        }
        //傭車先管理画面の場合
        else if (this.router.url.indexOf("partner") > -1) {
            this.companyService.getPartnerList(this.currPage, this.isLeaveCompanyPage, false)
                .subscribe(
                    data => {
                        this.companyList = data['results'];
                        this.totalCount = data['count'];
                    }
                );
        }
        //荷主管理画面の場合
        else if (this.router.url.indexOf("client") > -1) {
            this.companyService.getClientList(this.currPage, this.isLeaveCompanyPage)
                .subscribe(
                    data => {
                        this.companyList = data['results'];
                        this.totalCount = data['count'];
                    }
                );
        }
    }


    //ページ移動
    pageChange(page: number) {
        this.currPage = page;
        this.getCompanyList();
    }


    //会社登録
    registCompany() {
        if (this.f.invalid) {
            return;
        }

        if (this.currentCompany.comp_type == COMP_TYPE.HEAD) {
            this.messageService.addError("本社は新規登録できません。");
            return;
        }

        // (20240318) 営業所（branch）を登録する場合、group_nameに「㈱大興」を設定する
        if (this.currentCompany.comp_type == COMP_TYPE.BRANCH)  this.currentCompany.parent_group_name = "㈱大興";

        // this.mapService.getLatLngFromAddress(this.currentCompany.address + this.currentCompany.address_detail)
        // .then(
        //     data => {
        //         this.currentCompany.address_lat = data.lat();
        //         this.currentCompany.address_lng = data.lng();
        //         this.clearCustomError("address_detail");

        //         if (this.isPartnerClientPage) {
        //             this.member.company = this.currentCompany;
        //             this.member.user = this.currentUser;
        //             this.memberRegisterService.registMember(this.member)
        //             .subscribe(
        //                 data => {
        //                     this.messageService.addInfo((this.currentCompany.comp_type==COMP_TYPE.CLIENT?"荷主":"傭車先")+"が正常登録されました。");
        //                     this.refreshPage();
        //                 }
        //             );
        //         }
        //         else {
        //             this.companyService.registCompany(this.currentCompany)
        //             .subscribe(
        //                 data => {
        //                     //sessionStorage.setItem("logon_comp_lat", data['address_lat'].toString());
        //                     //sessionStorage.setItem("logon_comp_lng", data['address_lng'].toString());
        //                     this.refreshPage();
        //                 }
        //             );
        //         }
        //     }
        // )
        // .catch(
        //     error => {
        //         this.currentCompany.address_lat = null;
        //         this.currentCompany.address_lng = null;
        //         this.setCustomError("address_detail");
        //     }
        // );

        this.companyService.registCompany(this.currentCompany)
        .subscribe(
            data => {
                this.messageService.addInfo(this.pageTitle + "が新規登録されました。");
                this.refreshPage();
            }
        );
    }


    //会社更新
    updateCompany() {
        // this.mapService.getLatLngFromAddress(this.currentCompany.address + this.currentCompany.address_detail)
        // .then(
        //     data => {
                let compType = this.isPartnerClientPage ? (this.currentCompany.comp_type == COMP_TYPE.CLIENT ? "荷主" : "傭車先") : "営業所";
        //         this.currentCompany.address_lat = data.lat();
        //         this.currentCompany.address_lng = data.lng();
        //         this.clearCustomError("address_detail");

                if (this.isPartnerClientPage) {
                    this.member.company = this.currentCompany;
                    this.member.user = this.currentUser;
                    if (this.member.user.password) {
                        this.companyService.updateCompanyWithUser(this.member)
                        .subscribe(
                            data => {
                                this.messageService.addInfo(compType + "「" + this.currentCompany.name + "」の情報が正常更新されました。");
                                this.refreshPage();
                            }
                        );
                    } else {
                        this.companyService.updateCompany(this.currentCompany)
                        .subscribe(
                            data => {
                                this.messageService.addInfo(compType + "「" + this.currentCompany.name + "」の情報が正常更新されました。");
                                this.refreshPage();
                            }
                        );
                    }
                }
                else {
                    this.companyService.updateCompany(this.currentCompany)
                    .subscribe(
                        data => {
                            data.comp_type_name = this.currentCompany.comp_type_name;
                            this.companyList.splice(this.companyList.findIndex(({comp_id}) => comp_id === data.comp_id), 1, data);
                            this.messageService.addInfo(compType + "「" + this.currentCompany.name + "」の情報が正常更新されました。");
                            this.refreshPage();
                        }
                    );
                }
        //   }
        // )
        // .catch(
        //     error => {
        //         this.currentCompany.address_lat = null;
        //         this.currentCompany.address_lng = null;
        //         this.setCustomError("address_detail");
        //     }
        // );
    }

    //会社削除
    deleteCompany() {
        this.companyService.deleteCompany(this.currentCompany.comp_id)
            .subscribe(
                data => {
                    //this.companyList.splice(this.companyList.findIndex(({comp_id}) => comp_id === data.comp_id), 1);

                    this.refreshPage();
                }
            );
    }

    //会社復活
    reviveCompany() {
        this.companyService.updateCompany(this.currentCompany)
            .subscribe(
                data => {
                    //this.companyList.splice(this.companyList.findIndex(({comp_id}) => comp_id === data.comp_id), 1);

                    this.refreshPage();
                }
            );
    }


    //画面リフレッシュ
    refreshPage(): void {
        this.getCompanyList();
        this.companyService.fetchCompanyListForCombo();
        this.clearSelectCompany();
        $('#companyUpdateModal').modal('hide');
    }

    //入力欄クリア
    clearSelectCompany(): void {
        this.currentCompany = new Company();
        this.currentUser = new User();

        if (this.router.url == "/member/partner") {
            this.currentCompany.parent_comp_id = LOGON_INFO.COMP_ID;
            this.currentCompany.comp_type = COMP_TYPE.PARTNER;
            this.currentUser.div = USER_TYPE.TRANS_HAISHAMAN;
        } else if (this.router.url == "/member/client") {
            this.currentCompany.parent_comp_id = LOGON_INFO.COMP_ID;
            this.currentCompany.comp_type = COMP_TYPE.CLIENT;
            this.currentUser.div = USER_TYPE.CLIENT;
        } else if (this.router.url == "/member/company") {
            this.currentCompany.comp_type = COMP_TYPE.BRANCH;
            this.currentCompany.menu_type = "";
        }

        this.f.resetForm(this.currentCompany);
        this.messageService.clearError();
    }


    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registCompany();
                break;
            case "修正":
                this.updateCompany();
                break;
            case "削除":
                this.deleteCompany();
                break;
            case "復活":
                this.reviveCompany();
                break;
        }
    }


    setCustomError(control_name: string) {
        this.f.controls[control_name].setErrors({'custom':true});
        $('#'+control_name).addClass("is-invalid");
    }

    clearCustomError(control_name: string) {
        this.f.controls[control_name].setErrors(null);
        $('#'+control_name).removeClass("is-invalid");
    }


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/member-kanri/company.component.ts